import React from "react";
import { FaHandshake, FaRocket, FaMapMarkerAlt } from "react-icons/fa";
import "./Values.css";

const values = [
  {
    icon: FaHandshake,
    title: "Transparence totale",
    desc: "Pas de jargon, pas de surprise. On vous explique ce qu'on fait, pourquoi on le fait, et combien ca coute — avant de commencer.",
  },
  {
    icon: FaRocket,
    title: "Livraison rapide",
    desc: "Un site vitrine livre en 7 jours. Une application en quelques semaines. On respecte les delais parce qu'on sait que votre activite ne peut pas attendre.",
  },
  {
    icon: FaMapMarkerAlt,
    title: "Ancrage local",
    desc: "On est a Abidjan, on connait le marche ivoirien. Orange Money, Wave, mobile-first : on integre les reels usages de vos clients des le debut.",
  },
];

export default function Values() {
  return (
    <section className="values">
      <h2>Nos Valeurs</h2>
      <div className="values-list">
        {values.map((v) => {
          const Icon = v.icon;
          return (
            <div className="value-item" key={v.title}>
              <div className="value-icon">
                <Icon size={26} />
              </div>
              <h3>{v.title}</h3>
              <p>{v.desc}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
}
